import React from "react";
import styled from "styled-components";
import { getIconCultura } from "../../commons/utils";
import { SelectorMenu, SelectorOption } from "../../components/SelectorMenu"; // Importando corretamente

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
`;

interface FiltroCulturaProps {
    data: any[];
    culturaChecked: { id: string, descricao: string };
    onChecked: (selected: { id: string, descricao: string }) => void;
}

const FiltroCultura: React.FC<FiltroCulturaProps> = ({ data, culturaChecked, onChecked }) => {
    const culturaOptions: SelectorOption[] = [];
    const culturaSet = new Set<string>();

    data?.forEach((_data) => {
        if (!culturaSet.has(_data.cultdescricao)) {
            culturaSet.add(_data.cultdescricao);

            culturaOptions.push({
                id: _data.cultid,
                name: _data.cultdescricao,
                icon: <img src={getIconCultura(_data.cultdescricao)} width={28} alt="ícone cultura" style={{ marginRight: '8px' }} />,
            });
        }
    });

    const handleSelect = (selectedId: string, selectedName: string) => { onChecked({ id: selectedId, descricao: selectedName }) };

    return (
        culturaChecked &&
        <Container>
            <SelectorMenu
                options={culturaOptions}
                selectedId={culturaChecked?.id}
                onSelect={handleSelect}
            />
        </Container>
    )
};

export default FiltroCultura;
